import useSWR from "swr";

const useTariffs = () => {
  const { data } = useSWR("/tariffs");

  return data;
};

export default useTariffs;
